<template>
  <div class="preAlertDetail">
    <van-form label-width="120px">
      <van-field
        v-model="form.ManifestNumber"
        label="MANIFEST NO."
        label-class="number-label"
        readonly
      >
        <template #button>
          <van-button size="small" type="info" @click="onCopy(form.ManifestNumber)">{{
            $t.meta.copy
          }}</van-button>
        </template>
      </van-field>
      <van-field v-model="stateStr" :label="$t.preAlert.status" readonly />
      <van-field v-model="businessTypeStr" :label="$t.preAlert.businessType" readonly />
      <van-field v-model="form.PWB_Number" :label="$t.preAlert.mainWbNumber" readonly />
      <van-field v-model="form.Pol" :label="$t.preAlert.deliveryCity" readonly />
      <van-field v-model="form.Pod" :label="$t.preAlert.destinationCity" readonly />
      <van-field v-model="form.FlightNumber" :label="$t.preAlert.flightNumber" readonly />
      <van-field v-model="form.TotalHawb" :label="$t.preAlert.totalHawb" readonly />
      <van-field
        v-model="isTransitshipemnt"
        :label="$t.preAlert.transitshipment"
        readonly
      />
      <van-field v-model="form.TotalNumber" :label="$t.preAlert.totalNumber" readonly />
      <van-field v-model="form.GrossWeight" :label="$t.preAlert.weight" readonly />
      <van-field v-model="form.Volume" :label="$t.preAlert.volume" readonly />
      <van-field v-model="form.ETD" :label="$t.preAlert.etd" readonly />
      <van-field v-model="form.ATD" :label="$t.preAlert.atd" readonly />
      <van-field v-model="form.ETA" :label="$t.preAlert.eta" readonly />
      <van-field v-model="form.ATA" :label="$t.preAlert.ata" readonly />
      <van-field
        v-model="form.ShipperCustomerName"
        label="SHIPPER"
        type="textarea"
        rows="3"
        readonly
      />
      <van-field
        v-model="form.ConsigneeCustomerName"
        label="CONSIGNEE"
        type="textarea"
        rows="3"
        readonly
      />
      <van-field
        v-model="form.Remark"
        :label="$t.preAlert.remark"
        type="textarea"
        rows="3"
        readonly
      />
    </van-form>
    <div class="title">{{ $t.preAlert.log }}</div>
    <van-steps
      direction="vertical"
      active-color="#38f"
      :active="0"
      v-if="logs && logs.length > 0"
    >
      <van-step v-for="(log, index) in logs" :key="index">
        <h3>{{ log.OperationInstructionsStr }}</h3>
        <div style="margin-bottom: 5px">
          {{ $t.preAlert.operator }}: {{ log.UserName }}
        </div>
        <div style="margin-bottom: 5px">{{ $t.preAlert.date }}: {{ log.CreateTime }}</div>
        <div style="margin-bottom: 5px">
          {{ $t.preAlert.mail }}: {{ log.SendEmailRecipient }}
        </div>
        <div>{{ $t.preAlert.push }}: {{ log.CompanyName }}</div>
      </van-step>
    </van-steps>

    <div class="tool-bar">
      <van-button type="info" block @click="toPreAlert">
        {{ $t.meta.editButton }} Pre-Alert
      </van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import { Form, Field, Button, Icon, Image, Step, Steps } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image).use(Step).use(Steps);

export default {
  name: "preAlertDetail",
  data() {
    return {
      ManifestNumber: "",
      PAId: "",
      form: {},
      logs: [],
      businessTypeStr: this.$t.meta.wbType1,
      stateStr: this.$t.preAlert.state1,
      isTransitshipemnt: this.$t.meta.yes,
      type: "detail",
    };
  },
  created() {
    const { ManifestNumber, PAId, Type } = this.$route.query;
    this.type = Type;
    if (ManifestNumber) {
      this.ManifestNumber = ManifestNumber;
    } else {
      this.PAId = PAId;
    }
    this.getPreAlertInfo();
    this.getPreAlterOperationLogList();
  },
  methods: {
    toPreAlert() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "preAlert",
        name: "preAlert",
        query: [
          {
            name: "PAId",
            value: this.PAId,
          },
          {
            name: "Type",
            value: this.type,
          },
        ],
      });
    },
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
    getPreAlertInfo() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {};
        if (this.ManifestNumber) {
          param.ManifestNumber = this.ManifestNumber;
        } else {
          param.PAId = this.PAId;
        }
        this.$api.logisticsManagement
          .getPreAlertInfo(param)
          .then((res) => {
            this.form = res.data || [];
            if (this.form.BusinessType == 1) {
              this.businessTypeStr = this.$t.meta.wbType1;
            }
            if (this.form.BusinessType == 2) {
              this.businessTypeStr = this.$t.meta.wbType2;
            }
            if (this.form.BusinessType == 3) {
              this.businessTypeStr = this.$t.meta.wbType3;
            }
            if (this.form.BusinessType == 4) {
              this.businessTypeStr = this.$t.meta.wbType4;
            }
            if (this.form.BusinessType == 5) {
              this.businessTypeStr = this.$t.meta.wbType5;
            }
            if (this.form.AlertState == 0) {
              this.stateStr = this.$t.preAlert.state1;
            }
            if (this.form.AlertState == 1) {
              this.stateStr = this.$t.preAlert.state2;
            }
            if (this.form.AlertState == 2) {
              this.stateStr = this.$t.meta.disable;
            }
            if (this.form.IsTransitshipemnt == 1) {
              this.isTransitshipemnt = this.$t.meta.yes;
            } else {
              this.isTransitshipemnt = this.$t.meta.no;
            }
            this.$commonMethod.fieldRefresh(".preAlertDetail");
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    getPreAlterOperationLogList() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          PAId: this.PAId,
        };
        this.$api.logisticsManagement
          .getPreAlterOperationLogList(param)
          .then((res) => {
            this.logs = res.data.Data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.preAlertDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }

  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }

  .van-cell::after {
    border: none !important;
  }

  .van-steps {
    background: transparent;
  }

  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);

    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
